import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AppMtMenuService {

    private itemsSource = new Subject<void>();

    reloadHandler = this.itemsSource.asObservable();

    reloadItems() {
        this.itemsSource.next();
    }
}
